<div class="campaign-progress" *ngIf="campaign">
  <h4><i class="fa-solid fa-chart-line"></i> Progreso de Canales</h4>
  
  <!-- Barra de progreso general -->
  <div class="progress-overview">
    <div class="progress-info">
      <span class="progress-label">Progreso General</span>
      <span class="progress-value">{{ completedChannels }}/{{ totalChannels }} canales</span>
    </div>
    <p-progressBar 
      [value]="progressPercentage" 
      [showValue]="false"
    ></p-progressBar>
    <small>{{ progressPercentage }}% completado</small>
  </div>

  <!-- Lista de canales -->
  <div class="channels-list mt-3">
    <h5>Canales Configurados</h5>
    
    <!-- Canales pendientes de ejecución -->
    <div 
      *ngFor="let channel of campaign.channels" 
      class="channel-item"
      [class.executed]="isChannelExecuted(channel)"
    >
      <div class="channel-header">
        <i [class]="getChannelIcon(channel)"></i>
        <span class="channel-name">{{ channel }}</span>
      </div>
      
      <!-- Resultado si ya se ejecutó -->
      <ng-container *ngIf="getChannelResult(channel) as result">
        <div class="channel-result">
          <div class="result-info">
            <span 
              class="result-badge"
              [style.background-color]="getResultStatusColor(result.success, result.error)"
            >
              {{ getResultStatusLabel(result.success, result.error) }}
            </span>
            <small *ngIf="result.error" class="error-message">
              <i class="fa-solid fa-circle-exclamation"></i> {{ result.error }}
            </small>
            <small *ngIf="result.success && result.emailId" class="email-id">
              <i class="fa-solid fa-check-circle"></i> ID: {{ result.emailId }}
            </small>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Mensaje si no hay resultados aún -->
    <div *ngIf="!hasResults()" class="no-results">
      <i class="fa-solid fa-clock"></i>
      <p>La campaña aún no ha sido ejecutada. Los resultados aparecerán aquí una vez que se ejecute.</p>
    </div>
  </div>
</div>
